export default __webpack_public_path__ + "media/images/43-6bb388833fc1c9cdd17a97f7ae41e49b.png";